import { createStatic as e } from "styled-components-breakpoint";
import { hexToRgbA as t } from "@taxfix/scouts-helpers";
//#region src/constants.ts
var n = 2147483100, r = 2147483200, i = 2147483300, a = {
	tablet: 737,
	desktop: 1025,
	desktopLarge: 1281
}, o = {
	primary: {
		backgroundLight: "#ECFFC7",
		background: "#CEF5A4",
		main: "#154618",
		light: "#36893B",
		primaryAction: "#A0D766",
		secondaryAction: t("#A9D481", .4),
		hover: t("#A9D481", .2),
		pressed: t("#A9D481", .4),
		contrast: "#154618",
		resting: t("#A9D481", .4)
	},
	secondary: {
		backgroundLight: "#E8F0FF",
		background: "#B6C5F3",
		main: "#4C4991",
		light: "#668CFF",
		primaryAction: "#C6D2F6",
		secondaryAction: t("#C6D2F6", .4),
		hover: t("#C6D2F6", .2),
		pressed: t("#C6D2F6", .4),
		contrast: "#4C4991",
		resting: t("#C6D2F6", .4)
	},
	neutral: {
		backgroundLight: "#F9F7F5",
		background: "#F2EFED",
		main: t("#0C0B0A", .8),
		light: t("#0C0B0A", .65),
		primaryAction: "#DCD8D2",
		secondaryAction: t("#DCD8D2", .5),
		hover: t("#DCD8D2", .25),
		pressed: t("#DCD8D2", .5),
		contrast: t("#0C0B0A", .8),
		resting: t("#DCD8D2", .5)
	},
	success: {
		backgroundLight: "#ECFFC7",
		background: "#CEF5A4",
		main: "#154618",
		light: "#36893B",
		primaryAction: "#A0D766",
		secondaryAction: t("#A9D481", .4),
		hover: t("#A9D481", .2),
		pressed: t("#A9D481", .4),
		contrast: "#154618",
		resting: t("#A9D481", .4)
	},
	error: {
		backgroundLight: "#FEEBE7",
		background: "#F5A894",
		main: "#912003",
		light: "#FB5E36",
		primaryAction: "#FBB3A2",
		secondaryAction: t("#FBB3A2", .4),
		hover: t("#FBB3A2", .2),
		pressed: t("#FBB3A2", .4),
		contrast: "#912003",
		resting: t("#FBB3A2", .4)
	},
	accent1: {
		backgroundLight: "#FDF8F2",
		background: "#EAE0D7",
		main: "#0C0B0A",
		light: "#9A9288"
	},
	accent2: {
		backgroundLight: "#F6EBFE",
		background: "#DBB9F3",
		main: "#604587",
		light: "#BC73F2"
	},
	accent3: {
		backgroundLight: "#FFEFD3",
		background: "#F8C677",
		main: "#66541A",
		light: "#F8A21A"
	},
	accent4: {
		backgroundLight: "#FFF0F6",
		background: "#FEB9D6",
		main: "#9D2054",
		light: "#F53183"
	},
	accent5: {
		backgroundLight: "#D9F7E9",
		background: "#96E4BE",
		main: "#0D6359",
		light: "#04A491"
	},
	accent6: {
		backgroundLight: "#F2F5F7",
		background: "#BDCCD6",
		main: "#415562",
		light: "#758E9F"
	},
	accent7: {
		backgroundLight: "#FDF9D3",
		background: "#EFE272",
		main: "#5C5200",
		light: "#FDE200"
	},
	accent8: {
		backgroundLight: "#FCF6F2",
		background: "#ECD3C1",
		main: "#824417",
		light: "#CE7B40"
	},
	text: {
		title: "#0C0B0A",
		primary: t("#0C0B0A", .8),
		secondary: t("#0C0B0A", .65),
		disabled: t("#0C0B0A", .5),
		contrastText: "#FFFFFF"
	},
	grey: {
		background: "#FFFFFF",
		surface1: "#F2EFED",
		surface2: "#F9F7F5",
		surface3: "#FFFFFF",
		divider: t("#0C0B0A", .12),
		dividerContrast: t("#FFFFFF", .16),
		graphics1: "#0C0B0A",
		graphics2: "#96928E",
		graphics3: "#E4E1DD",
		graphics90: t("#0C0B0A", .9),
		graphics70: t("#0C0B0A", .7),
		graphics30: t("#0C0B0A", .3),
		graphics10: t("#0C0B0A", .1)
	},
	common: {
		active: t("#A0D766", .2),
		hover: t("#0C0B0A", .1),
		pressed: t("#0C0B0A", .2),
		disabled1: "#E4E1DD",
		disabled2: "#F2EFED",
		handle: "#FFFFFF"
	},
	background: {
		sky: "#E8F0FF",
		straw: "#FDF9D3",
		peach: "#FEEBE7",
		lime: "#ECFFC7",
		background1: "#E8F0FF",
		background2: "#FDF9D3",
		background3: "#FEEBE7",
		background4: "#ECFFC7",
		background5: "#F6EBFE",
		background6: "#FFEFD3",
		background7: "#FFF0F6",
		background8: "#D9F7E9",
		background9: "#F2F5F7",
		background10: "#FCF6F2"
	}
}, s = {
	surface: {
		base: o.grey.background,
		inverted: o.grey.graphics1,
		neutral: o.neutral.backgroundLight,
		highlightSoft: o.secondary.backgroundLight,
		highlight: o.secondary.backgroundLight,
		affirmSoft: o.primary.backgroundLight,
		affirm: o.primary.background,
		affirmInverted: o.primary.contrast,
		accentSoft: o.accent2.backgroundLight,
		accent: o.accent2.backgroundLight,
		accentInverted: o.accent2.main,
		attention: o.accent3.backgroundLight,
		alert: o.error.background,
		interactive: o.primary.primaryAction,
		note: o.accent3.backgroundLight,
		noteStrong: o.accent3.background,
		affirmStrong: {
			20: "#dcfdf3",
			40: "#a4f5d3",
			60: "#6fe69d",
			70: "#16cf98",
			80: "#007963"
		}[60],
		attentionStrong: {
			40: "#fff4a0",
			60: "#ffd676"
		}[60]
	},
	text: {
		base: o.text.title,
		inverted: o.text.contrastText,
		neutral: o.text.secondary,
		interactive: o.primary.main,
		affirm: o.success.main,
		alert: o.error.main
	},
	line: {
		base: o.grey.graphics1,
		inverted: o.grey.background,
		neutral: o.grey.graphics2,
		neutralLight: o.grey.graphics3,
		neutralSoft: o.neutral.backgroundLight,
		affirm: o.primary.background,
		highlight: o.secondary.background,
		interactive: o.secondary.light
	},
	icon: {
		base: o.grey.graphics1,
		neutral: o.grey.graphics2
	},
	brand: {
		whatsapp: "#25d366",
		facebook: "#4267B2",
		google: "#DB4437"
	}
}, c = { interactive: {
	thin: `1px solid ${s.line.interactive}`,
	medium: `2px solid ${s.line.interactive}`
} }, l = {
	family: {
		body: "ABCROM, Helvetica Neue, helvetica, arial, sans-serif",
		display: "ABCROMExtended, arial, sans-serif"
	},
	weight: {
		normal: "normal",
		medium: "500",
		semiBold: "600",
		bold: "700"
	},
	body: {
		small: "12px",
		medium: "14px",
		large: "16px",
		xlarge: "20px"
	},
	title: {
		smaller: "12px",
		small: "14px",
		medium: "16px",
		large: "20px",
		xlarge: "24px"
	},
	display: {
		small: "20px",
		medium: "24px",
		large: "30px",
		xlarge: "36px",
		xxlarge: "48px"
	},
	tiny: "10px",
	smaller: "12px",
	small: "14px",
	normal: "16px",
	large: "20px",
	larger: "24px",
	big: "36px",
	huge: "48px"
}, u = (e, t) => e * t, d = {
	fonts: {
		ABCROM: "ABCROM, Helvetica Neue, helvetica, arial, sans-serif",
		ABCROMExtended: "ABCROMExtended, arial, sans-serif"
	},
	typography: {
		heading1Large: {
			fontFamily: "ABCROM",
			fontSize: {
				xs: 32,
				sm: 48,
				lg: 64
			},
			fontWeight: 700,
			letterSpacing: {
				xs: u(32, -.01),
				sm: u(48, -.01),
				lg: u(64, -.01)
			},
			lineHeight: {
				xs: 40,
				sm: 60,
				lg: 84
			}
		},
		heading2Large: {
			fontFamily: "ABCROM",
			fontSize: {
				xs: 32,
				sm: 48,
				lg: 64
			},
			fontWeight: 700,
			letterSpacing: {
				xs: u(32, -.01),
				sm: u(48, -.01),
				lg: u(64, -.01)
			},
			lineHeight: {
				xs: 40,
				sm: 60,
				lg: 84
			}
		},
		h1: {
			fontFamily: "ABCROM",
			fontSize: {
				xs: 28,
				sm: 40,
				lg: 48
			},
			fontWeight: 700,
			letterSpacing: {
				xs: u(28, -.01),
				sm: u(40, -.01),
				lg: u(48, -.01)
			},
			lineHeight: {
				xs: 36,
				sm: 52,
				lg: 60
			}
		},
		h2: {
			fontFamily: "ABCROM",
			fontSize: {
				xs: 24,
				sm: 32,
				lg: 40
			},
			fontWeight: 700,
			letterSpacing: {
				xs: u(24, -.01),
				sm: u(32, -.01),
				lg: u(40, -.01)
			},
			lineHeight: {
				xs: 32,
				sm: 40,
				lg: 52
			}
		},
		h3: {
			fontFamily: "ABCROM",
			fontSize: {
				xs: 20,
				sm: 24,
				lg: 28
			},
			fontWeight: 700,
			letterSpacing: {
				xs: u(20, -.01),
				sm: u(24, -.01),
				lg: u(28, -.01)
			},
			lineHeight: {
				xs: 28,
				sm: 32,
				lg: 36
			}
		},
		h4: {
			fontFamily: "ABCROM",
			fontSize: {
				xs: 18,
				sm: 20
			},
			fontWeight: 700,
			letterSpacing: {
				xs: u(18, -.01),
				sm: u(20, -.01)
			},
			lineHeight: {
				xs: 24,
				sm: 28
			}
		},
		h5: {
			fontFamily: "ABCROM",
			fontSize: { xs: 16 },
			fontWeight: 700,
			letterSpacing: { xs: u(16, -.01) },
			lineHeight: { xs: 20 }
		},
		h6: {
			fontFamily: "ABCROM",
			fontSize: { xs: 14 },
			fontWeight: 700,
			letterSpacing: { xs: u(14, -.01) },
			lineHeight: { xs: 20 }
		},
		"accent-h1": {
			fontFamily: "ABCROMExtended",
			fontSize: {
				xs: 28,
				sm: 40,
				lg: 48
			},
			fontWeight: 900,
			letterSpacing: {
				xs: u(28, -.01),
				sm: u(40, -.01),
				lg: u(48, -.01)
			},
			lineHeight: {
				xs: 36,
				sm: 52,
				lg: 60
			}
		},
		"accent-h2": {
			fontFamily: "ABCROMExtended",
			fontSize: {
				xs: 24,
				sm: 32,
				lg: 40
			},
			fontWeight: 900,
			letterSpacing: {
				xs: u(24, -.01),
				sm: u(32, -.01),
				lg: u(40, -.01)
			},
			lineHeight: {
				xs: 32,
				sm: 40,
				lg: 52
			}
		},
		"accent-h3": {
			fontFamily: "ABCROMExtended",
			fontSize: {
				xs: 20,
				sm: 24,
				lg: 28
			},
			fontWeight: 900,
			letterSpacing: {
				xs: u(20, -.01),
				sm: u(24, -.01),
				lg: u(28, -.01)
			},
			lineHeight: {
				xs: 28,
				sm: 32,
				lg: 36
			}
		},
		"accent-h4": {
			fontFamily: "ABCROMExtended",
			fontSize: {
				xs: 18,
				sm: 20
			},
			fontWeight: 900,
			letterSpacing: {
				xs: u(18, -.01),
				sm: u(20, -.01)
			},
			lineHeight: {
				xs: 24,
				sm: 28
			}
		},
		"accent-h5": {
			fontFamily: "ABCROMExtended",
			fontSize: { xs: 16 },
			fontWeight: 900,
			letterSpacing: { xs: u(16, -.01) },
			lineHeight: { xs: 20 }
		},
		"accent-h6": {
			fontFamily: "ABCROMExtended",
			fontSize: { xs: 14 },
			fontWeight: 900,
			letterSpacing: { xs: u(14, -.01) },
			lineHeight: { xs: 20 }
		},
		bodyLarge: {
			fontFamily: "ABCROM",
			fontSize: {
				xs: 20,
				sm: 24,
				lg: 28
			},
			fontWeight: 400,
			lineHeight: {
				xs: 28,
				sm: 32,
				lg: 36
			}
		},
		body: {
			fontFamily: "ABCROM",
			fontSize: { xs: 16 },
			fontWeight: 400,
			lineHeight: { xs: 20 }
		},
		bodyLong: {
			fontFamily: "ABCROM",
			fontSize: { xs: 16 },
			fontWeight: 400,
			lineHeight: { xs: 24 }
		},
		bodySmall: {
			fontFamily: "ABCROM",
			fontSize: { xs: 14 },
			fontWeight: 400,
			lineHeight: { xs: 20 }
		},
		overline: {
			fontFamily: "ABCROM",
			textTransform: "uppercase",
			fontSize: {
				xs: 10,
				lg: 12
			},
			fontWeight: 500,
			letterSpacing: {
				xs: u(10, .04),
				lg: u(12, .04)
			},
			lineHeight: { xs: 16 }
		},
		link: {
			fontFamily: "ABCROM",
			fontSize: { xs: 16 },
			fontWeight: 500,
			lineHeight: { xs: 20 },
			textTransform: "none"
		},
		linkSmall: {
			fontFamily: "ABCROM",
			fontSize: { xs: 14 },
			fontWeight: 500,
			lineHeight: { xs: 20 },
			textTransform: "none"
		},
		button: {
			fontFamily: "ABCROM",
			fontSize: { xs: 16 },
			fontWeight: 500,
			lineHeight: { xs: 20 }
		},
		buttonSmall: {
			fontFamily: "ABCROM",
			fontSize: { xs: 14 },
			fontWeight: 500,
			lineHeight: { xs: 20 }
		},
		buttonCaption: {
			fontFamily: "ABCROM",
			fontSize: { xs: 12 },
			fontWeight: 500,
			lineHeight: { xs: 16 }
		}
	}
}, { tablet: f, desktop: p, desktopLarge: m } = e(a);
//#endregion
export { d as a, o as c, i as d, a as f, l as i, r as l, m as n, c as o, f as r, s, p as t, n as u };

//# sourceMappingURL=styles-BtQZqITL.js.map